import { EAcademyBlockType } from "../../RentmatchAcademy.types";
import { parseAcademyBody } from "../../RentmatchAcademy.utils";
import { AcademyHighlight } from "../AcademyHighlight";
import * as S from "./AcademyText.styles";

interface IAcademyTextProps {
  text: string;
  // A search to mark in the text, when the broker came from a search result.
  query?: string;
}

export const AcademyText = ({ text, query }: IAcademyTextProps) => (
  <S.Wrap>
    {parseAcademyBody(text).map((block, index) => {
      if (block.type === EAcademyBlockType.Bullets) {
        return (
          <S.List key={index}>
            {block.items.map((item, itemIndex) => (
              <li key={`${itemIndex}-${item}`}>
                <AcademyHighlight text={item} query={query} />
              </li>
            ))}
          </S.List>
        );
      }

      return (
        <S.Paragraph key={index}>
          <AcademyHighlight text={block.text} query={query} />
        </S.Paragraph>
      );
    })}
  </S.Wrap>
);
